module.exports = __webpack_public_path__ + "img/video-target-tracking.bb6881d2.png";